// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"b7d856b9","347":"f8b6bd51","394":"436dac4b","454":"ce7df0d8","468":"52a163f1","501":"7dfaf617","808":"dd03961b","873":"aa1d7e2e","928":"cae35534"}[chunkId] + ".chunk.js";
};